import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'surface-legend-svg',
  templateUrl: './surface_legend.svg',
  styleUrl: './surface-legend-svg.css',
  standalone: true,
  imports: [CommonModule]
})
export class SurfaceSvgComponent {}
